import { Theme } from "@mui/material/styles"

export const SharedResizeHandleStyles = (theme: Theme) => ({
	cursor: "ew-resize !important",
	backgroundColor: "transparent",
	zIndex: 1302,
	"&:hover": {
		backgroundColor: theme.palette.primary.main + "4D", // 30% opacity
	},
})